<script setup>
import { computed, ref } from 'vue';
import BaseBubble from './Base.vue';
import AudioTranscriptionState from './AudioTranscriptionState.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const transcript = ref(null);
const attachment = computed(() => ({
  ...attachments.value[0],
  ...(transcript.value === null ? {} : { transcribedText: transcript.value }),
}));
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
    <AudioTranscriptionState v-if="attachment.id" :key="attachment.id"
      :attachment-id="attachment.id" :source="attachments[0]" @transcript="transcript = $event" />
  </BaseBubble>
</template>
